import React, { useState, useEffect } from 'react';
import { PriceDelivery, allPolygon } from '../../server/Polygon';
import { ShippingAddressPost, ShippingAddressDelete } from '../../server/ShippingAddress'
import { useSelector, useDispatch } from 'react-redux'
import showAlert, { showAlertWithConfirmCancel } from '../../server/ShowAlert';
import Autocomplete from 'react-google-autocomplete';
import { setPreload } from '../../server/CartsOpen';
import Input from '../containers/InputForm';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import * as actionType from '../../store/action';
import { UpdateCustomerStationId } from '../../server/Customer';

const schema = yup.object({
    Name: yup.string().required("שם חובה"),
    StreetNumber: yup.string().required("חובה להכניס מס' בניין"),
    HouseNumber: yup.string().required("חובה להכניס מס' בית ").test('len', "לא תקין", x => !isNaN(x) || x.length <= 3),
    Floor: yup.string().required('חובה להכניס קומה').test('len', "לא תקין", x => x.length <= 12),
    Entry: yup.string().test('len', "לא תקין", x => x?.length <= 20),
    AddressComment: yup.string(),
}).required();


const NewAddress = ({ pushAddress, address, polygonState, onlyStreet, closeSignUpPopup, oldStationId, setNewAddress}) => {
    const dispatch = useDispatch();

    const { user, stationId } = useSelector(state => ({
        user: state.user.user,
        stationId: state.stationId,
    }));
    
    const { register, handleSubmit, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            Name: user?.LastName || "",  
        }
    });
    const [town, setTown] = useState("")
    const [streetName, setStreetName] = useState("")
    const [lng, setLng] = useState("")
    const [lat, setLat] = useState("");
    const [checkBox, setCheckBox] = useState(true);
    const [elevators, setElevators] = useState("noElevators");
    const [always, setAlways] = useState(true);
    const [userStationId, setUserStationId] = useState(stationId);
    const [addressList, setAddressList] = useState(address); 
    const [changeAddress, setChangeAddress] = useState(true);
    const [selectedAddress, setSelectedAddress] = useState(""); 
    const [defaultName, setDefaultName] = useState(user?.LastName || "");

    useEffect(() => {
        if (user?.LastName) {
            setValue("Name", user.LastName);
        }
    }, [user, setValue]);    

    const saveAddress = (data) => {
        dispatch(setPreload(true));
        data.CustomerId = user.Id;
        data.lat = lat;
        data.lng = lng;
        data.town = town;
        data.streetName = streetName;
        data.MainAddress = checkBox ? 1 : 0;
        data.IsElevator = elevators === "noElevators" ? false : true;
        ShippingAddressPost(data)
            .then(x => {
                x.data["MainAddress"] = checkBox ? 1 : 0
                pushAddress(x.data, address);
                dispatch({ type: actionType.VERIFIED_EMAIL })
                setAddressList(prevAddress => [...prevAddress, x.data]);
            })
            .catch(() => console.log("error"))
            .finally(() => dispatch(setPreload(false)));
        dispatch(UpdateCustomerStationId(user.Id, userStationId))
        oldStationId = userStationId;
    }

    const setLocation = async (place) => { 
        let polygon;
        if (!place.geometry) {
            showAlert({ msgTitle: 'אנא הזינו את שם הרחוב בלבד ובחרו מהשדות המוצעות לכם', msgTimer: '3000', msgType: 'info' })
            return;
        }
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        let newPolygon = polygonState.length ? polygonState : [];
        if (!newPolygon.length) {
            try {
                const response = await allPolygon();
                polygon = response.data.map(item => item.polygon).flat();
                polygonState = polygon;
            } catch (error) {
                showAlert({ msgTitle: 'שגיאה בטעינת אזורי משלוח, נסו שוב מאוחר יותר', msgType: 'error' });
                return;
            }
        }
        polygon = polygonState;
        const polygonPriceId = PriceDelivery(lat, lng, polygon);
        const polygonId = polygonPriceId?.PolygonStationId;
        if (polygonId) {
            if(polygonId != oldStationId && addressList?.length){
                setChangeAddress(false);
                setChangeAddress(prev => {
                    if (!prev) {
                        showAlertWithConfirmCancel({
                            msgTitle: '  ',
                            html: `
                                <h1>אופס,</h1>
                                <h2>הכתובת שלך מעודכנת באזור אחר!</h2>
                                <h3>האם ברצונך לשנות תחנה?</h3>
                                <h3>שים לב, בשינוי תחנה הכתובות הקודמות ימחקו.</h3>
                            `,
                            confirmText: "המשך בכל זאת",
                            cancelText: "ביטול",
                            onConfirm: () => {
                                ShippingAddressDelete(user.Id);
                                setChangeAddress(true);
                            },
                            onCancel: () => {
                                setSelectedAddress("");
                            }
                        });
                    }
                    return false;
                });
            } 
            if(changeAddress){
                setUserStationId(polygonId);
                if(user){
                    user.StationId = polygonId;
                }
                if (place.address_components.length === 4) {
                    setStreetName(place.address_components[0].long_name)
                    setTown(place.address_components[1].long_name)
                }
                else if (place.address_components.length <= 6 && place.address_components.length >= 5) {
                    if (place.address_components[0].types[0] === "street_number") {
                        setValue('StreetNumber', place.address_components[0].long_name)
                        setStreetName(place.address_components[1].long_name)
                        setTown(place.address_components[2].long_name)
                    }
                    else if (place.address_components[0].types[0] === "route") {
                        setStreetName(place.address_components[0].long_name)
                        setTown(place.address_components[1].long_name)
                    }
                }
                else if (place.address_components.length < 4) {
                    showAlert({ msgTitle: 'אנא הזינו את שם הרחוב ועיר המגורים', msgType: 'error' })
                    return;
                }
                setLat(place.geometry.location.lat());
                setLng(place.geometry.location.lng());
                showAlert({ msgTitle: 'מצויין, אנו מגיעים אליכם.', msgType: 'success' })
                closeSignUpPopup();
            }
        } else {
            showAlert({ msgTitle: 'אופס, איננו מבצעים משלוחים לאיזור זה. עמכם הסליחה.', msgType: 'error' })
            setNewAddress(false);
        }
    }
    return (
        <div className="add-address">
            {onlyStreet ? (
                <></>
            ) : (
                <span className='note'>שדות חובה מסומנים ב*</span>
            )} 
            <form className="register" onSubmit={handleSubmit(saveAddress)}>
            {always ? (
                <span className="autocomplete-address">
                {onlyStreet ? (
                    <></>
                ) : (
                    <p className="autocomplete-address-title">רחוב*</p>
                )}
                    <Autocomplete
                        className="autocomplete-address-input"
                        options={{
                            componentRestrictions: { country: 'ISR' },
                            types: ['geocode'],
                        }
                        }
                        onPlaceSelected={(e) => {
                            setSelectedAddress(e.formatted_address);
                            setLocation(e);
                        }}
                        value={selectedAddress}
                        onChange={(e) => setSelectedAddress(e.target.value)}
                        placeholder='הזינו את שם הרחוב ובחרו מתוך האפשרויות המוצעות לכם'
                    />

                </span>
            ) : null}
            {onlyStreet ? (
                <></>
            ) : (
                <>
                <span className='details-address'>
                    <span className='name'>
                        <Input
                            type="text"
                            register={register}
                            label="שם מקום האספקה"
                            errors={errors}
                            name="Name" />
                    </span>
                    <span className='sub-details'>
                        <Input
                            type="number"
                            register={register}
                            label="מס' בית*"
                            errors={errors}
                            name="StreetNumber" />
                        <Input
                            type="text"
                            register={register}
                            label="כניסה"
                            errors={errors}
                            name="Entry" />
                        <Input
                            type="number"
                            register={register}
                            label="קומה*"
                            errors={errors}
                            name="Floor" />
                        <Input
                            type="number"
                            register={register}
                            label="מס' דירה*"
                            errors={errors}
                            name="HouseNumber" />
                    </span>
                </span>
                <span className='note-shipping'>
                    <Input
                        type="text"
                        register={register}
                        label="הערות למשלוחן"
                        errors={errors}
                        name="AddressComment" />

                    <span className='elevators-radio-btn'>
                        <span className='elevators'>
                            <input type="radio" onChange={(e) => setElevators(e.target.value)} id="yesElevators" value="yesElevators" name="elevators" checked={elevators === "yesElevators"} />
                            <label className="yesElevators">יש מעלית</label>
                        </span>
                        <span className='elevators'>
                            <input type="radio" onChange={(e) => setElevators(e.target.value)} id="noElevators" value="noElevators" name="elevators" checked={elevators === "noElevators"} />
                            <label className="noElevators"> אין מעלית</label>
                        </span>
                    </span>
                </span>
                <span className='checkbox-and-btn'>
                    <div className='checkbox-style'>
                        <input
                            type="checkBox"
                            checked={checkBox}
                            onChange={() => setCheckBox(!checkBox)} />
                        <label>הגדר ככתובת ברירת מחדל</label>
                    </div>
                    <button className='btn' type="submit" >{"שמור > "}</button>
                </span>
                </>
            )}
            </form>
        </div>
    )
}

export default NewAddress;